import { PopUpBase } from './PopUpBase';

export type { TypePopUpBaseProps } from './types';
export default PopUpBase;
